<template>
  <section>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-6">
          <a @click.prevent="reloadNetwork" href="#" class="btn btn-primary btn-block m-btn m-btn--icon">
            <span>
              <i class="flaticon-map"></i>
              <span>{{ 'reload_network' | translate | capitalize }}</span>
            </span>
          </a>
        </div>
        <div class="col-md-6">
          <a @click.prevent="reloadWebServer" href="#" class="btn btn-primary btn-block m-btn m-btn--icon">
            <span>
              <i class="flaticon-browser"></i>
              <span>{{ 'reload_web_server' | translate | capitalize }}</span>
            </span>
          </a>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-6">
          <a @click.prevent="reloadServer" href="#" class="btn btn-primary btn-block m-btn m-btn--icon">
            <span>
              <i class="flaticon-tool"></i>
              <span>{{ 'reboot_server' | translate | capitalize }}</span>
            </span>
          </a>
        </div>
          <div class="col-md-6">
            <a @click.prevent="reloadSync" href="#" class="btn btn-primary btn-block m-btn m-btn--icon">
              <span>
                <i class="flaticon-tool"></i>
                <span>{{ 'reboot_sync' | translate | capitalize }}</span>
              </span>
            </a>
          </div>
      </div>
    </div>
  
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" @click="resetForm" id="btn-cancel">
        {{ 'close' | translate | capitalize }}
      </button>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({modal: 'getStatusReloadModal'})
  },
  methods: {
    ...mapActions(['setStatusReloadModal', 'reloadNetwork', 'rebootServer', 'restartWebServer', 'rebootSync']),
    resetForm () {
      window.$('#reload_modal').modal('hide')
      this.setStatusReloadModal(false)
    },
    reloadServer () {
      this.$spinner.show()
      this.rebootServer()
        .then(() => {
          this.$spinner.remove()
          this.$toast('reboot_server_ok', 1)
          window.location.reload()
        })
        .catch(() => {
          this.$spinner.remove()
          this.$toast('reboot_server_fail', 4)
          window.location.reload()
        })
    },
    reloadWebServer () {
      this.$spinner.show()
      this.restartWebServer()
        .then(() => {
          this.$spinner.remove()
          this.$toast('reload_web_server_ok', 1)
          window.location.reload()
        })
        .catch(() => {
          this.$spinner.remove()
          this.$toast('reload_web_server_fail', 4)
          window.location.reload()
        })
    },
    reloadNetwork () {
      this.$spinner.show()
      this.reloadNetwork()
        .then(() => {
          this.$spinner.remove()
          this.$toast('reload_network_ok', 1)
          window.location.reload()
        })
        .catch(() => {
          this.$spinner.remove()
          this.$toast('reload_network_fail', 4)
          window.location.reload()
        })
    },
    reloadSync () {
      this.$spinner.show()
      this.rebootSync()
        .then(() => {
          this.$spinner.remove()
          this.resetForm()
          this.$toast('reboot_sync_ok', 1)
        })
        .catch(() => {
          this.$spinner.remove()
          this.resetForm()
          this.$toast('reboot_sync_fail', 4)
        })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Reload.vue